import React, { FC, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Holiday from "./tabs/Holiday";
import { Wrapper } from "../styled";

const vacationsTabs = [
{
    title: "Отпуска",
    component: <Holiday/>,
}
];

const Vacations: FC = () => {
const [tab, setTab] = useState(0);

const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
};

return (
    <Wrapper>
    <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
    >
        {vacationsTabs.map((tab) => (
        <Tab key={tab.title} label={tab.title} />
        ))}
    </Tabs>
    {vacationsTabs[tab].component}
    </Wrapper>
);
};

export default Vacations;
